import {Component, computed, signal} from '@angular/core';
import {StringUtils} from '../../lib/strings';

export interface MessageToastOptions {
    title?: string;
    message?: string;
    type?: 'success' | 'error' | 'info';
    timeout?: number;
}

const DefaultTimeout = 2000;

@Component({
    selector: 'app-message-toast',
    templateUrl: './message-toast.component.html',
    styleUrls: ['./message-toast.component.scss'],
    imports: [],
    standalone: true
})
export class MessageToastComponent {

    protected readonly title = signal<string>('');
    protected readonly text = signal<string>('');
    protected readonly isEmpty = computed(() => StringUtils.isNullOrEmpty(this.text()));
    protected readonly visible = signal(false);
    private scheduledTimeout: ReturnType<typeof setTimeout> | undefined;

    constructor() { }

    private cancelScheduledTimeout() {
        if (this.scheduledTimeout) {
            clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = undefined;
        }
    }

    show(options: MessageToastOptions) {
        this.cancelScheduledTimeout();
        if (options.message) {
            this.title.set(options.title ?? '');
            this.text.set(options.message);
        }
        this.visible.set(true);
        this.scheduledTimeout = setTimeout(() => this.hide(), options.timeout ?? DefaultTimeout);
    }

    hide() {
        this.cancelScheduledTimeout();
        this.visible.set(false);
    }

    onToastClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.hide();
        //this.cancelScheduledTimeout();
        //this.show({timeout: 15_000});
    }

    onHandleClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.show({ timeout: 30_000});
    }
}
